import { Box, Card, CardContent, Divider, Grid, TextField, Typography } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TreeItem from "@material-ui/lab/TreeItem";
import TreeView from "@material-ui/lab/TreeView";
import "moment-timezone";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import {
  getAllChildModulesAction,
  getAllParentModulesAction,
  getRoleByIdAction,
  getSelectedModuleCheckboxesAction,
} from "src/app-redux/management/actions/managementActions";
import {
  loading,
  selectAllParentModules,
  selectCurrentUserRole,
  selectRoleSelectedMapping,
} from "src/app-redux/management/managementSlice";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonButton from "src/components/CommonButton/CommonButton";
import TabHeader from "src/components/TabHeader/TabHeader";
import { ManagementRoute } from "../../../../management.routes";
import { ActionsComponent } from "./ActionsComponent";
import { useStyles } from "./style";
import CommonLoader from "src/components/Loader/CommonLoader";

interface Props {}

export function AssignPermissions({}: Props): React.ReactElement {
  const classes = useStyles();

  const [moduleName, setmoduleName] = useState<any>(ManagementRoute.title);
  const [pageHeading, setpageHeading] = useState<any>("Roles & Permissions");
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const { terminalId } = useParams<{ terminalId: string }>();
  const { height } = UseWindowDimensions();
  let wHeight = 0;
  let gridMaxHeight = 0;
  let dppr = 10;
  wHeight = height - 132;
  gridMaxHeight = height - 200;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }
  useEffect(() => {
    dispatch(getAllParentModulesAction(terminalId));
    dispatch(getRoleByIdAction({ roleId: id, terminalId: terminalId }));
    dispatch(getSelectedModuleCheckboxesAction({ roleId: id, terminalId: terminalId }));
  }, []);

  const [showCheckboxActions, setShowCheckboxActions] = useState<any>(false);
  const [childModuleId, setchildModuleId] = useState<any>("");
  const loader = useAppSelector(loading);
  const parentModules = useAppSelector(selectAllParentModules);
  const currentURole: any = useAppSelector(selectCurrentUserRole);
  const roleSelectedActions: any = useAppSelector(selectRoleSelectedMapping);
  const [submitCounter, setSubmitCounter] = useState(0);

  useEffect(() => {
    //
  }, [roleSelectedActions]);

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} />
      <Backdrop className={classes.backdrop} open={loader}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Card>
        <CardContent
          className={classes.cardMain}
          // style={{ height: wHeight }}
          style={{ height: "1800px" }}
        >
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid md={10}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}>{pageHeading}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={2} direction="row">
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => setSubmitCounter((prev) => prev + 1)}
                >
                  Assign Permissions
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
          <Divider />

          <Box style={{ marginBottom: "30px" }} />

          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={4}>
              <Box>
                <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Selected User Role"
                  name="role"
                  disabled={true}
                  value={currentURole?.roleName}
                />
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginTop: "15px" }}>
            <Divider />
          </Box>

          {/* Permissions Area Started */}
          <Grid container direction="row" style={{ marginTop: "20px" }}>
            <Grid md={4}>
              <div className={classes.rolesLeftSection}>
                <Typography className="subHeading">{"List of Activities"}</Typography>
                <div className={classes.tab}>
                  <TreeView
                    className={classes.tree}
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronRightIcon />}
                  >
                    {parentModules.map((item: any) => (
                      <div key={item.moduleId}>
                        <TreeItem
                          nodeId={item.moduleId}
                          label={item.moduleName}
                          onLabelClick={() => {
                            setShowCheckboxActions(false);
                          }}
                          onIconClick={() => {
                            setShowCheckboxActions(false);
                          }}
                          className={classes.treeItem}
                        >
                          {item.childModules.map((child: any) => (
                            <TreeItem
                              key={child.moduleId}
                              nodeId={child.moduleId}
                              label={child.moduleName}
                              className={classes.treeItem}
                              onLabelClick={() => {
                                setchildModuleId(child.moduleId);
                                setShowCheckboxActions(true);
                              }}
                            ></TreeItem>
                          ))}
                        </TreeItem>
                      </div>
                    ))}
                  </TreeView>
                </div>
              </div>
            </Grid>
            <Grid md={4}>
              <ActionsComponent
                submitCounter={submitCounter}
                roleId={id}
                terminalId={terminalId}
                childModuleId={childModuleId}
                isShow={showCheckboxActions}
                roleSelectedActions={roleSelectedActions}
              />
            </Grid>
          </Grid>
          {/* Permissions Area Ended */}
        </CardContent>
      </Card>
    </>
  );
}
